import * as yup from 'yup';

const mobilePaymentSchema = yup
    .object({
        referenceCode: yup
            .string()
            .min(6, 'Referencia debe tener al menos 6 dígitos')
            .required('Referencia requerida'),
        bankId: yup.number().min(1).required('Debe seleccionar un banco'),
        date: yup
            .string()
            .matches(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD inválido')
            .required('Fecha requerida'),
        phone: yup
            .string()
            .matches(
                /^04(12|14|24|16|26|22)\d{7}$/,
                'Formato 04XXXXXXXXX inválido'
            )
            .required('Teléfono requerido'),
        nin: yup.string().min(3, 'CI inválida').required('CI requerida'),
    })
    .required();

const casheaSchema = yup.string().min(3).required();

const zelleSchema = yup.string().min(3).required();

export { mobilePaymentSchema, casheaSchema, zelleSchema };
